import classNames from 'classnames/bind';
import parse, {
  HTMLReactParserOptions,
  attributesToProps,
  domToReact,
} from 'html-react-parser';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export interface QuoteProps {
  id?: any;
  text?: string;
  children?: string;
  [key: string]: any;
}

export const Quote = ({ id, children, text, ...rest }: QuoteProps) => {
  const cx = classNames.bind(styles);
  const { query } = useRouter();
  const params = new URLSearchParams(JSON.parse(JSON.stringify(query)));
  const paramsString = params.toString();

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      if (
        domNode.name === 'a' &&
        domNode.attribs &&
        !domNode.attribs.href.startsWith('mailto:')
      ) {
        const props = attributesToProps(domNode.attribs);
        return (
          <a
            {...props}
            href={`/${id}/outbound?url=${encodeURIComponent(
              domNode.attribs.href,
            )}&${paramsString}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {domToReact(domNode.children, options)}
          </a>
        );
      }
    },
  };

  let content = text || children;
  content =
    content && content.indexOf('<p>') > -1 ? content : `<p>${content}</p>`;

  return (
    <section className={cx('component', 'quote', rest)}>
      {content && <blockquote>{parse(content, options)}</blockquote>}
    </section>
  );
};

Quote.defaultProps = {
  text: '',
} as Partial<QuoteProps>;
